export const getRandomColor = () => {
    const colorArray = ["#CABDFF", "#B1E5FC", "#B5E4CA",'#FFBC99'];
    const randomIndex = Math.floor(Math.random() * colorArray.length);
    return colorArray[randomIndex];
}